import AmenitiesContainer from "./AmenitiesContainer";
import AmenitiesStore from "./AmenitiesStore";
export default AmenitiesStore(AmenitiesContainer);